module.exports = __webpack_public_path__ + "img/bottles_grey.efbc1c4e.svg";